import { Component, Input, OnInit } from '@angular/core';
import { RequeteModifierCoordonnees } from 'src/app/api/model/requete-modifier-coordonnees.model';
import { GlobalStoreService } from 'src/app/services/global-store/global-store.service';

type CompteAffichable = {
  descriptionCourte: string;
  numeroCarte: string;
  adresseCourriel: string;
};

@Component({
  selector: 'app-valider-courriel',
  templateUrl: './valider-courriel.component.html',
  styleUrls: ['./valider-courriel.component.scss'],
  standalone: false,
})
export class ValiderCourrielComponent implements OnInit {
  @Input() requeteModifierCoordonnees: RequeteModifierCoordonnees;
  comptesAffichable: Array<CompteAffichable> = [];
  isMultiple = false;

  constructor(protected globalStoreService: GlobalStoreService) {}

  ngOnInit(): void {
    this.globalStoreService.getCoordonneesClient$().subscribe((data) => {
      if (data) {
        this.isMultiple = data.comptesDetention.length > 1;
        data.comptesDetention
          .filter((compte) => compte.infosCompte.codeRelation !== 'ADI')
          .forEach((compte) => {
            const courrielModifie = this.requeteModifierCoordonnees.infosComptes.find(
              (infoCompte) => infoCompte.numeroCompte === compte.infosCompte.numeroCompte
            );
            this.comptesAffichable.push({
              descriptionCourte: compte.infosCarte.descriptionCourte,
              numeroCarte: compte.infosCarte.numeroCarte,
              adresseCourriel: courrielModifie ? courrielModifie.adresseCourriel : compte.infosCompte.adresseCourriel,
            });
          });
      }
    });
  }
}
